import styled from 'styled-components';
import colors from 'theme/colors';

export const DrawerTitle = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 1.25rem;
  line-height: 1.5rem;
`;

export const TitleFileContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 52.813rem;
  align-items: center;
  button {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 1.375rem;
  }
`;

export const FileContainer = styled.div`
  height: 52.813rem;
  background: ${colors.white};
  box-shadow: 0.125rem 0.25rem 0.75rem rgba(0, 0, 0, 0.15);
`;

export const ResolutionContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 23rem;
  height: 50rem;
  overflow-y: scroll;
  background: ${colors.white};
  box-shadow: 0.125rem 0.25rem 0.75rem rgba(0, 0, 0, 0.15);

  textarea {
    width: 20rem;
  }

  form.form-textarea {
    padding-left: 1.5rem;
  }
`;

export const ResolutionText = styled.div`
  padding: 0.625rem 1.5rem 0.625rem 1.5rem;
`;

export const ResolutionTextBottom = styled.div`
  padding: 0 0.625rem 1.5rem 1.5rem;
`;

export const ResolutionTitle = styled.div`
  padding: 0.625rem 1.563rem 0.625rem 1.563rem;
  background: ${colors.white};
  box-shadow: 0.125rem 0.25rem 0.75rem rgb(0 0 0 / 15%);
  width: 22.938rem;
`;

export const DrawerFooter = styled.div`
  width: 100%;
  height: 3.125rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 0.125rem;
  button.ant-btn-primary {
    margin-left: 1rem;
  }
  button {
    font-family: Nunito;
    font-style: normal;
    font-weight: bold;
    font-size: 0.875rem;
    line-height: 1.375rem;
  }
`;
